'use client';

import { useContext } from 'react';
import { StoreDispatchContext } from '../context';

export function useStoreDispatch() {
    const context = useContext(StoreDispatchContext);

    if (!context) {
        throw new Error('useStoreDispatch must be used inside <StoreProvider />');
    }

    return context;
}
